function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var DEFAULT_GENESIS_PERIOD = 80640;
var ATR_TRANSACTION_TYPE = 3;
function slipPublicKey(slip) {
  return (slip === null || slip === void 0 ? void 0 : slip.publicKey) || (slip === null || slip === void 0 ? void 0 : slip.public_key) || '';
}
function slipAmountValue(slip) {
  if (slip == null) {
    return 0n;
  }
  try {
    var _slip$amount;
    return BigInt((_slip$amount = slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0);
  } catch (err) {
    return 0n;
  }
}
function isScriptingPublicKey(app, publicKey) {
  if (!publicKey) {
    return false;
  }
  try {
    var _app$crypto;
    if (app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.fromBase58) {
      var hex = app.crypto.fromBase58(String(publicKey));
      return hex.startsWith('00');
    }
  } catch (err) {
    // fall through to raw hex check
  }
  var raw = String(publicKey).toLowerCase();
  return raw.startsWith('00') && raw.length >= 4;
}
function normalizeTransaction(tx) {
  var _tx$type2;
  if (!tx) {
    return null;
  }
  if (typeof tx.toJson === 'function') {
    var _ref, _ref2, _tx$type;
    var json = {};
    try {
      json = JSON.parse(tx.toJson());
    } catch (err) {
      json = {};
    }
    return {
      signature: tx.signature || json.signature || json.hash || '',
      type: (_ref = (_ref2 = (_tx$type = tx.type) !== null && _tx$type !== void 0 ? _tx$type : tx.transaction_type) !== null && _ref2 !== void 0 ? _ref2 : json.type) !== null && _ref !== void 0 ? _ref : json.transaction_type,
      from: Array.isArray(tx.from) ? tx.from : json.from || [],
      to: Array.isArray(tx.to) ? tx.to : json.to || []
    };
  }
  return {
    signature: tx.signature || tx.hash || '',
    type: (_tx$type2 = tx.type) !== null && _tx$type2 !== void 0 ? _tx$type2 : tx.transaction_type,
    from: Array.isArray(tx.from) ? tx.from : [],
    to: Array.isArray(tx.to) ? tx.to : []
  };
}
function isAtrTransaction(tx) {
  var _tx$type3;
  if (!tx) {
    return false;
  }
  var type = (_tx$type3 = tx.type) !== null && _tx$type3 !== void 0 ? _tx$type3 : tx.transaction_type;
  if (type === 'ATR') {
    return true;
  }
  return Number(type) === ATR_TRANSACTION_TYPE;
}
function collectTransactionPublicKeys(tx) {
  var keys = new Set();
  var _iterator = _createForOfIteratorHelper(tx.from || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      var publicKey = slipPublicKey(slip);
      if (publicKey) {
        keys.add(publicKey);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(tx.to || []),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _slip = _step2.value;
      var _publicKey = slipPublicKey(_slip);
      if (_publicKey) {
        keys.add(_publicKey);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return keys;
}
function txHasScriptingAddress(app, tx) {
  for (var _i = 0, _arr = [].concat(_toConsumableArray(tx.from || []), _toConsumableArray(tx.to || [])); _i < _arr.length; _i++) {
    var slip = _arr[_i];
    if (isScriptingPublicKey(app, slipPublicKey(slip))) {
      return true;
    }
  }
  return false;
}
function computeRecipient(app, publicKey, tx, allKeys) {
  if (isScriptingPublicKey(app, publicKey)) {
    return 2;
  }
  if (txHasScriptingAddress(app, tx)) {
    return 2;
  }
  var otherKeys = new Set(allKeys);
  otherKeys["delete"](publicKey);
  if (otherKeys.size === 0) {
    return 0;
  }
  return 1;
}
function computeDelta(publicKey, tx) {
  if (isAtrTransaction(tx)) {
    var deposit = 0n;
    var _iterator3 = _createForOfIteratorHelper(tx.to || []),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var slip = _step3.value;
        if (slipPublicKey(slip) === publicKey) {
          deposit += slipAmountValue(slip);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return deposit;
  }
  var delta = 0n;
  var _iterator4 = _createForOfIteratorHelper(tx.from || []),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _slip2 = _step4.value;
      if (slipPublicKey(_slip2) === publicKey) {
        delta -= slipAmountValue(_slip2);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var _iterator5 = _createForOfIteratorHelper(tx.to || []),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _slip3 = _step5.value;
      if (slipPublicKey(_slip3) === publicKey) {
        delta += slipAmountValue(_slip3);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return delta;
}
function collectToPublicKeys(tx) {
  var keys = new Set();
  var _iterator6 = _createForOfIteratorHelper(tx.to || []),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var slip = _step6.value;
      var publicKey = slipPublicKey(slip);
      if (publicKey) {
        keys.add(publicKey);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return keys;
}
function toStorageInteger(value) {
  if (typeof value === 'bigint') {
    return value.toString();
  }
  return value;
}
function buildAddressRowsFromTransaction(app, tx, blockMeta) {
  var normalized = normalizeTransaction(tx);
  if (!(normalized !== null && normalized !== void 0 && normalized.signature)) {
    return [];
  }
  var allKeys = collectTransactionPublicKeys(normalized);
  if (!allKeys.size) {
    return [];
  }
  var isAtr = isAtrTransaction(normalized);
  var keysToProcess = isAtr ? collectToPublicKeys(normalized) : allKeys;
  var rows = [];
  var _iterator7 = _createForOfIteratorHelper(keysToProcess),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var publicKey = _step7.value;
      var delta = computeDelta(publicKey, normalized);

      // Normal txs: skip zero/negative net movement (self-change, fee-only, etc.).
      // ATR txs: exempt — delta is the full output deposit, not net in/out.
      // Prior rows for older blocks are removed when ATR rebroadcast prunes.
      if (!isAtr && delta <= 0n) {
        continue;
      }
      if (delta <= 0n) {
        continue;
      }
      rows.push({
        publickey: publicKey,
        tx_hash: normalized.signature,
        block_hash: blockMeta.block_hash,
        block_id: blockMeta.block_id,
        is_longest_chain: blockMeta.is_longest_chain,
        recipient: computeRecipient(app, publicKey, normalized, allKeys),
        delta: toStorageInteger(delta)
      });
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return rows;
}
function buildAddressRowsFromBlock(app, block) {
  var longestChain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!(block !== null && block !== void 0 && block.id) || !(block !== null && block !== void 0 && block.hash)) {
    return [];
  }
  var blockMeta = {
    block_id: toStorageInteger(block.id),
    block_hash: block.hash,
    is_longest_chain: longestChain ? 1 : 0
  };
  var transactions = Array.isArray(block.transactions) ? block.transactions : [];
  var rows = [];
  for (var i = 0; i < transactions.length; i++) {
    rows.push.apply(rows, _toConsumableArray(buildAddressRowsFromTransaction(app, transactions[i], blockMeta)));
  }
  return rows;
}
function blockContainsAtrTransaction(block) {
  var transactions = Array.isArray(block === null || block === void 0 ? void 0 : block.transactions) ? block.transactions : [];
  for (var i = 0; i < transactions.length; i++) {
    var normalized = normalizeTransaction(transactions[i]);
    if (isAtrTransaction(normalized)) {
      return true;
    }
  }
  return false;
}
function returnGenesisPeriod(app) {
  var _app$options;
  var configured = Number(app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.consensus) === null || _app$options === void 0 ? void 0 : _app$options.genesis_period);
  if (Number.isFinite(configured) && configured > 0) {
    return Math.floor(configured);
  }
  return DEFAULT_GENESIS_PERIOD;
}
module.exports = {
  DEFAULT_GENESIS_PERIOD: DEFAULT_GENESIS_PERIOD,
  ATR_TRANSACTION_TYPE: ATR_TRANSACTION_TYPE,
  buildAddressRowsFromBlock: buildAddressRowsFromBlock,
  buildAddressRowsFromTransaction: buildAddressRowsFromTransaction,
  blockContainsAtrTransaction: blockContainsAtrTransaction,
  computeDelta: computeDelta,
  computeRecipient: computeRecipient,
  isAtrTransaction: isAtrTransaction,
  isScriptingPublicKey: isScriptingPublicKey,
  returnGenesisPeriod: returnGenesisPeriod
};